import { jsonFetch, typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { CUSTOMER_DEVICES_URL, reassignDeviceUrl, retireDeviceUrl } from "./api-url.constants";
import { CustomerDeviceActionError } from "./customer-device-action.error";
import { CustomerDevicesList, RetiredDeviceStatus } from "./customer-devices.models";

/**
 * Devices of the logged customer, or of the customer chosen by Lexeon staff
 * (`userId` of that customer).
 */
export const getCustomerDevices = async (userId?: string): Promise<CustomerDevicesList> => {
  const url = userId
    ? `${CUSTOMER_DEVICES_URL}?userId=${encodeURIComponent(userId)}`
    : CUSTOMER_DEVICES_URL;
  const response = await jsonFetch<{ data: CustomerDevicesList }>(url);
  return response.data;
};

const postAction = async (url: string, body: object): Promise<void> => {
  const response = await typedFetch(url, {
    method: API_METHODS.POST,
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const message = Array.isArray(error.message) ? error.message.join(", ") : error.message;
    throw new CustomerDeviceActionError(message || "Unexpected error", response.status);
  }
};

export interface RetireDeviceParams {
  roomId: string;
  monitorId: string;
  status: RetiredDeviceStatus;
}

export const retireDevice = ({ roomId, monitorId, status }: RetireDeviceParams): Promise<void> =>
  postAction(retireDeviceUrl(roomId), { monitorId, status });

export interface ReassignDeviceParams {
  roomId: string;
  monitorId: string;
  location: string;
}

export const reassignDevice = ({
  roomId,
  monitorId,
  location,
}: ReassignDeviceParams): Promise<void> =>
  postAction(reassignDeviceUrl(roomId), { monitorId, location });
